module.exports = __webpack_public_path__ + "img/unity.d0a94ebb.png";